import { lazier } from '@shared/components';

export const RecordAdvancement = lazier(
  () => import('./RecordAdvancementModal'),
  false,
);
export { default as RecordAdvancementButton } from './RecordAdvancementButton';
